module.exports = __webpack_public_path__ + "img/code-fork.cfb84e62.svg";